// extracted by mini-css-extract-plugin
export default {"root":"FileChip_root__ToDKA","icon":"FileChip_icon__0lzNW"};